import { Component, ViewChild } from "@angular/core";
import { EdpTokenInputComponent } from "@edp-components/edp-token-input/edp-token-input.component";
import { SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { AgreementContactResponse, AgreementContactUSed, AgreementValidatedResponse } from "@edp-models/edp-payment.model";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { EdpRecaptchaService } from "@edp-services/edpRecaptchaService.service";
import { NifService } from "@edp-services/nif.service";
import { PaymentService } from "@edp-services/payment.service";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { RecaptchaComponent } from "ng-recaptcha";

@Component({
    selector: "token-validation",
    templateUrl: "./token-validation.component.html",
    styleUrls: ["./token-validation.component.scss"],
})
export class TokenValidationComponent {
    @ViewChild(EdpTokenInputComponent) edpTokenInput: EdpTokenInputComponent;
    @ViewChild("captchaRef", { static: true }) captchaRef: RecaptchaComponent;

    public isError: boolean;
    public nif: string;
    public contact: AgreementContactResponse;
    public recaptchaToken = null;
    public recaptcha: any;
    public inputToken: string;

    constructor(
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private paymentService: PaymentService,
        private store: Store<IAppState>,
        private nifService: NifService,
        private steperService: EdpSteperService,
        private edpRecaptchaService: EdpRecaptchaService
    ) {
        this.nif = this.nifService.getNifValue().value;
        this.contact = this.edpPaymentAgreementService.getContactResponse();
    }

    public setToken(token: string) {
        this.store.dispatch(new ShowLoader(true));
        this.inputToken = token;
        this.executeRecaptcha();
    }

    public validateToken() {
        const args = {
            nif: this.nif,
            code: this.inputToken,
        };
        this.paymentService.validateToken(args).subscribe(
            (response: any) => {
                const res: AgreementValidatedResponse = response[0];
                if (!res.status) {
                    this.store.dispatch(new ShowLoader(false));
                    this.isError = true;
                    return;
                }
                this.steperService.setActiveStep(2);
                this.validateSelectedComponent(this.contact.used);                
                this.store.dispatch(new ShowLoader(false));
            },
            error => {
                console.error(error);
                this.isError = true;
                this.store.dispatch(new ShowLoader(false));
            }
        );
    }

    public resendToken() {
        this.isError = false;
        this.clearInput();
        this.store.dispatch(new ShowLoader(true));
        const args = {
            nif: this.nif,
        };

        this.paymentService.generateToken(args).subscribe(
            res => {
                console.log(res);
                this.store.dispatch(new ShowLoader(false));
            },
            error => {
                console.error(error);
                this.store.dispatch(new ShowLoader(false));
            }
        );
    }

    public clearInput() {
        this.edpTokenInput.clearInput();
    }

    public executeRecaptcha(): void {
        if (this.captchaRef) {
            this.captchaRef.execute();
            this.recaptcha = this.captchaRef;
        } else {
            console.error("Captcha reference is not available yet.");
        }
    }

    public resolved(captchaResponse: string): void {
        this.recaptchaToken = captchaResponse;
        if (this.recaptchaToken) {
            this.edpRecaptchaService.setContactResponse(this.recaptchaToken);
            this.validateToken();
        }
    }

    private validateSelectedComponent(used: string) {
        switch (used) {
            case AgreementContactUSed.NOT_FOUND_CONTACT:
                this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.NO_ASSOCIATED_CONTACT);
                 break;
            case AgreementContactUSed.NOT_FOUND_CUSTOMER:
                 console.log("NOT_FOUND_CUSTOMER");
                 break;
            case AgreementContactUSed.EMAIL:
                 this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.ELIGIBILITY);       
                 break;
            case AgreementContactUSed.MOBILE:
                 this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.ELIGIBILITY);      
                 break;
        }
    }
}
